import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceGyorgyOttucsak.jpeg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projOttucsakGY_factor.png";

const Gyorgy_Ottucsak_factor = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="Factor Hunting for AI Equities: Beyond Correlations"
            />{" "}
            <p className="text7">György Ottucsák</p>
            <br />
            <p className="text8">
              Executive Director{" "}
            </p>
            <p className="text8">Morgan Stanley</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            AI is creating new market linkages that are not well captured by static correlations: growth in AI compute drives 
            data-center expansion and rising electricity demand, which connects AI-exposed equities to power generation, grid 
            infrastructure, and capex cycles. In this project, students will build an orthogonal factor model (“factor lens”, 
            inspired by Two Sigma / Venn) to measure and monitor these dependencies for an AI equity basket using public market 
            and macro data. The work focuses on factor discovery/selection, orthogonalization (to avoid redundant drivers), and 
            professional risk and P&L attribution (“what drove performance and risk this month?”).  
            <br/>
            <br/>
            Interest in quantitative finance; solid statistics + linear algebra; Python (pandas/numpy) and regression/time-series. 
            Machine learning familiarity (model selection/regularization) is a plus.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gyorgy_Ottucsak_factor;